module.exports = __webpack_public_path__ + "static/media/386GriffinStNW_2018-06-05_48.3a63d3ea.jpg";